import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthorizationService } from '../../../../access/shared/authorization/authorization.service';
import { Permissions } from '../../../../access/shared/authorization/permissions';
import { ConfigService } from '../../../../config/config.service';
import { CommandeService } from '../../../linge-hebergement/shared/commande.service';
import { OrderService } from '../../../order/shared/order.service';
import { ClientService } from '../../../shared/client/client.service';
import { MenuItem } from './menu-item';
import { TypeMenuItem } from './type-menu-item';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  constructor(private authService: AuthorizationService,
    private orderService: OrderService,
    private configService: ConfigService,
    private clientService: ClientService,
    private commandeService: CommandeService,
    private http: HttpClient) {
  }

  private buildMenu(client) {
    let isOnHermine = client.site.is_on_hermine;
    let isOnLeanpay = client.site.is_on_leanpay;
    let menuItems = new Array<MenuItem>();
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_PRESTATION))
      menuItems.push(new MenuItem(
        'daily-operation',
        "Gestion au quotidien",
        TypeMenuItem.INTERNAL_APP,
        '/escli/daily-operation'
      ));
    if (this.authService.hasPermission(Permissions.ROLE_DEMANDES))
      menuItems.push(new MenuItem(
        'order-tracking',
        "Suivi des demandes",
        TypeMenuItem.INTERNAL_APP,
        '/escli/order-tracking',
        0,
        'demandes en cours'
      ));
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_HEBERGEMENT))
      menuItems.push(new MenuItem(
        'linge-hebergement',
        "Gestion linge d'hébergement",
        TypeMenuItem.INTERNAL_APP,
        '/escli/linge-hebergement',
        0,
        'Commandes en cours'
      ));
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_LIVRAISON))
      menuItems.push(new MenuItem(
        'delivery',
        "Livraisons",
        TypeMenuItem.INTERNAL_APP,
        '/escli/delivery'
      ));
    if (isOnLeanpay && this.authService.hasPermission(Permissions.ROLE_FACTURATION))
      menuItems.push(new MenuItem(
        'billing',
        "Facturation",
        TypeMenuItem.INTERNAL_APP,
        '/escli/billing'
      ));
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_STATISTIQUE))
      menuItems.push(new MenuItem(
        'statistic',
        "Statistiques",
        TypeMenuItem.INTERNAL_APP,
        '/escli/statistic'
      ));
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_LECTURECAB)) {
      if (this.authService.hasPermission(Permissions.ROLE_LECTURECAB_IMPORT)) {
        menuItems.push(new MenuItem(
          'cab',
          "Lecture",
          TypeMenuItem.INTERNAL_APP,
          '/escli/cab/import/lecture'
        ));
      } else {
        menuItems.push(new MenuItem(
          'cab',
          "Lecture",
          TypeMenuItem.INTERNAL_APP,
          '/escli/cab/historique'
        ));
      }
    }
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_DAV)) {
      menuItems.push(new MenuItem(
        'dav',
        "DAV",
        TypeMenuItem.INTERNAL_APP,
        '/escli/dav'
      ));
    }
    if (isOnHermine && this.authService.hasPermission(Permissions.ROLE_ANETT)) {
      menuItems.push(new MenuItem(
        'bordereaux',
        "Bordereaux",
        TypeMenuItem.INTERNAL_APP,
        '/escli/bordereaux'
      ));
    }

    return menuItems
  }

  public getMenuItems(client): Observable<Array<MenuItem>> {
    return of(this.buildMenu(client));
  }

  public countOrderInProcess(): Observable<number> {
    return this.orderService.countOrderInProcess(this.clientService.currentClient$.getValue());
  }
}
